import React from 'react';

const WipIcon = () => (
    <svg className="map-icon map-icon-wip" viewBox="0 0 48 48">
        <path
            className="map-icon-stroke-outter"
            d="M36.05,40.79H11.55a3,3,0,0,1-3-3V36.07a3,3,0,0,1,3-3h1.3L19.79,9a3,3,0,0,1,2.88-2.17h2.25A3,3,0,0,1,27.81,9l6.94,24.11h1.3a3,3,0,0,1,3,3v1.72A3,3,0,0,1,36.05,40.79Z"
        />
        <path
            className="map-icon-wip-fill"
            d="M36.05,38.79H11.55a1,1,0,0,1-1-1V36.07a1,1,0,0,1,1-1h2.06a1,1,0,0,0,1-.72h0L21.72,9.51a1,1,0,0,1,1-.72h2.25a1,1,0,0,1,1,.72L33,34.34a1,1,0,0,0,1,.72h2.06a1,1,0,0,1,1,1v1.72A1,1,0,0,1,36.05,38.79Z"
        />
        <polygon
            className="map-icon-wip-details"
            points="18.58 22.21 16.23 30.36 31.37 30.36 29.02 22.21 18.58 22.21"
        />
        <path
            className="map-icon-stroke-inner"
            d="M36.05,35.07H34a1,1,0,0,1-1-.72L25.89,9.51a1,1,0,0,0-1-.72H22.68a1,1,0,0,0-1,.72L14.57,34.34h0a1,1,0,0,1-.89.71H11.55a1,1,0,0,0-1,1v1.72a1,1,0,0,0,1,1h24.5a1,1,0,0,0,1-1V36.07A1,1,0,0,0,36.05,35.07Zm-15-5.2,4-7.15h2.83l-4,7.15Zm8.28-4.7,1.35,4.7h-4ZM22.68,9.79h2.25l3.43,11.93H19.24ZM19,22.72h3.25l-4,7.15H16.9ZM36.05,37.79H11.55V36.07H21a.5.5,0,1,0,0-1H15.32a1.94,1.94,0,0,0,.21-.43h0l1.08-3.76H31l1.08,3.76A2,2,0,0,0,34,36.07h2.06Z"
        />
    </svg>
);

export default React.memo(WipIcon);
